import { Component, OnInit, TemplateRef, ViewChild,Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarService } from '../../../_service/message-service';
import { Subscription } from 'rxjs';
import { LoaderService } from 'src/app/loader.service';
import { RfidServiceService } from 'src/app/_service/rfid-service.service';
import { TableBtn, TableColumn } from 'src/app/shared/interfaces';
import { GeneralDialogComponent } from 'src/app/shared/components/general-dialog/general-dialog.component';
import { ConfirmDialogComponent } from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from 'src/app/_services/user.service';
import { UserInfoService } from 'src/app/_services/userInfo.service';
import { Role } from 'src/app/util/enums/role.enum';
import { Permission } from 'src/app/util/enums/permission.enum';
import { MenuRouteID } from '../../header/menu-item/nav-item';
import { AuthenticationService } from 'src/app/_services';
import { RouteConstants } from 'src/app/util/route.constants';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';


@Component({
  selector: 'telio-rfid-list',
  templateUrl: './rfid-list.component.html',
  styleUrls: ['./rfid-list.component.scss']
})
export class RfidListComponent implements OnInit, OnDestroy {
  @Input() actionFeatureFlag = false;
  rfidSubscription = new Subscription()
  dataList;
  dataList2;
  allRfids;
  changeStatus;
  currentuser;
  userid;
  deleteId;
  disableEdit = false;
  disableAssign = false;
  disbleDelete = false;
  blockStatus = false;
  disableBlock = false;
  userId;
  comment;
  blockToolTip;
  rfidTag;
  actionFeatureLabel: string = 'rfid.createTitle';
  columns: TableColumn[];
  buttons: TableBtn[];
  rfidAssignedList: RFIDAssignedList[];
  subscription: Subscription = new Subscription;
  sortColumn = '';
  sortDirection = 'asc';
  pageList = {
    currentPage: 0,
    pageSize: 10
  };
  currentPage = 0;
  totalDataCount = 0;
  actionHeader: string = '';
  filterPlaceholder: string = '';
  userDetails: any;
  desplayRfid;
  availableTabs = [
    { id: MenuRouteID.TABS.ASSIGNED_RFID, enable: false },
    { id: MenuRouteID.TABS.CONSOLIDATED_RFID, enable: false }
  ];
  @ViewChild('viewUserDetails', { static: false }) viewUserDetails: TemplateRef<any>;
  @ViewChild('blockAlert', { static: false }) blockAlert: TemplateRef<any>;
  @ViewChild('viewRfidDetails', {static: false}) viewRfidDetails: TemplateRef<any>;

  constructor(
    private router: Router,
    private rfidService: RfidServiceService,
    public loaderService: LoaderService,
    private userInfoService: UserInfoService,
    private toastr: SnackbarService,
    public translate: TranslateService,
    readonly route: ActivatedRoute,
    private authenticationService:AuthenticationService,
    readonly dialog: MatDialog,
    private userService: UserService,readonly breadcrumbService: BreadcrumbService,
  ) {

    
  }

  ngOnInit() {
    this.availableTabs = this.userInfoService.getPermittedTabs(+this.route.snapshot.paramMap.get('routeID'), this.availableTabs);
    let tabExists = this.availableTabs.filter(res => res.enable);
    !tabExists || tabExists.length == 0 ? this.toastr.info(this.translate.instant('unAuthorized')) : '';
    this.columns = [
      { columnDef: 'idTag', header: 'rfid.rfidTag', cell: (element: RFIDAssignedList) => `${element.rfidTag}`, sortingDisabled: false, width: 'auto',  isLink: this.userInfoService.filterPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.READ)},
      { columnDef: 'userDetails', header: 'rfid.userDetails', cell: (element: RFIDAssignedList) => `${element.userDetails}`, sortingDisabled: true, width: 'auto', isLink: this.userInfoService.filterPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.READ)},
      { columnDef: 'mobile', header: 'rfid.userMobile', cell: (element: RFIDAssignedList) => `${element.userMobile}`, sortingDisabled: false, width: '120px' },
      { columnDef: 'createdByName', header: 'rfid.createdBy', cell: (element: RFIDAssignedList) => `${element.createdByName}`, sortingDisabled: false, width: '120px' },
      { columnDef: 'status', header: 'rfid.status', cell: (element: RFIDAssignedList) => `${element.status}`, sortingDisabled: false, width: 'auto', caseSensitive: 'uppercase' },
      { columnDef: 'masterRfidCard', header: 'rfid.masterTag', cell: (element: RFIDAssignedList) => `${element.masterRfidCard}`, sortingDisabled: false, width: 'auto' },
    ];


    this.buttons = [
      { styleClass: 'submit', icon: 'edit', payload: (element: RFIDAssignedList) => `${element.rfidTag}`, action: 'edit', tooltip: 'rfid.edit',enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) },
      { styleClass: 'submit', icon: 'visibility', payload: (element: RFIDAssignedList) => `${element.rfidTag}`, action: 'block', tooltip: 'rfid.block', isDisabled: (element: RFIDAssignedList) => `${!element.blockStatus}` ,enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE)},
      { styleClass: 'submit', icon: 'visibility_off', payload: (element: RFIDAssignedList) => `${element.rfidTag}`, action: 'unblock', tooltip: 'rfid.unBlock', isDisabled: (element: RFIDAssignedList) => `${!element.unblockStatus}`,enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.UPDATE) },
      { styleClass: 'submit', icon: 'delete', payload: (element: RFIDAssignedList) => `${element.rfidTag}`, action: 'delete', tooltip: 'rfid.discard', isDisabled: (element: RFIDAssignedList) => `${element.disableDelete}`,enable: this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.DELETE) },
    ];

    this.actionHeader = 'actions';
    this.filterPlaceholder = 'generalTable.filterPlaceholder';
    this.actionFeatureFlag = this.checkPermission(+this.route.snapshot.paramMap.get('routeID'), Permission.CREATE);
    this.currentuser = this.userInfoService.userDetails;

    this.userid = this.currentuser.userId
    this.getRFIDs(this.pageList, '');
  }

  getRFIDs(value: any, searchFilter: string = '') {
    if (this.userInfoService.isAdminGroup()) {
      this.getAllRfids(value, searchFilter);
    }
    else {
      this.getRfidByCpo(value, searchFilter);
    }
  }

  getRfidByCpo(value: any, searchFilter: string = '') {
    this.subscription.add(this.rfidService.getAssignedRfids( value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter)
      .subscribe((res: any) => {
        this.rfidAssignedList = res.content;
        this.totalDataCount = res.total_items;
        this.rfidAssignedList.map((item: any, i: number) => {
          let empty = 'NA';
          item.id = i;
          item.rfidTag = !item.id_tag ? empty : item.id_tag;
          item.userDetails = !item.username && !item.user_id ? empty : item.username + ' (' + item.user_id + ')';
          item.userMobile = !item.mobile ? empty : item.mobile;
          item.createdByName = !item.created_by_id ? empty : item.created_by_id;
          item.status = !item.status ? empty : item.status;
          item.masterRfidCard = !item.master_rfid_card ? empty : item.master_rfid_card;
          item.blockStatus = item.status.toLowerCase() == 'activated' ? true : item.status.toLowerCase() == 'blocked' ? true : false;
          item.unblockStatus = item.status.toLowerCase() == 'blocked' ? true : false;
          item.disableDelete = item.disableDelete;
        });
      }, err => {
        this.toastr.error(this.translate.instant('responseFailed'));
      }));
  }

  getAllRfids(value: any, searchFilter: string = '') {
    this.subscription.add(this.rfidService.getAssignedRfids(value.currentPage + 1, value.pageSize, this.sortColumn, this.sortDirection, searchFilter)
      .subscribe((res: any) => {
        this.rfidAssignedList = res.content;
        this.totalDataCount = res.total_items;
        this.rfidAssignedList.map((item: any, i: number) => {
          let empty = 'NA';
          item.id = i;
          item.rfidTag = !item.id_tag ? empty : item.id_tag;
          item.userDetails = !item.username && !item.user_id ? empty : item.username + ' (' + item.user_id + ')';
          item.userMobile = !item.mobile ? empty : item.mobile;
          item.createdByName = !item.created_by_id ? empty : item.created_by_id;
          item.status = !item.status ? empty : item.status;
          item.masterRfidCard = !item.master_rfid_card ? empty : item.master_rfid_card;
          item.blockStatus = item.status.toLowerCase() == 'activated' ? true : false;
          item.unblockStatus = item.status.toLowerCase() == 'blocked' ? true : false;
          item.disableDelete = item.disableDelete;
        });
      }, err => {
        this.toastr.error(this.translate.instant('responseFailed'));
      }));
  }

  blockCard(item) {
    this.comment = "";
    this.userId = item.user_id
    this.rfidTag = item.id_tag
    if (item.status.toLowerCase() == "activated") {
      let dialogRef = this.dialog.open(this.blockAlert, {
        height: '40vh',
        width: '800px'
      }).afterClosed().subscribe((res: any) => {
      })
    }
    else if (item.status.toLowerCase() == "blocked") {
      this.unblockFeature();
    }
    this.changeStatus = item.changeStatus

  }

  unblockById() {
    this.rfidSubscription.add(this.rfidService.unBlockRfidCard(this.authenticationService.convertToBase64(this.rfidTag)).subscribe(resp => {
      if (!!resp) {
        this.toastr.success(resp.status_message);
        this.getRFIDs(this.pageList, '');
      }
      else {
        this.toastr.error(this.translate.instant('rfid.unBlockError'))
      }
    },
      error => {
        this.toastr.error(error);
      }
    ))
  }

  rfidStatusChange() {
    if (this.comment == "") {
      this.toastr.error(this.translate.instant('rfid.commentError'))
      return;
    }
    let data = {
      "comments": this.comment,
      "status": "blocked"
    }
    this.rfidSubscription.add(this.rfidService.blockRfidCard(this.userId, data).subscribe(resp => {
      if (!!resp) {
        this.dialog.closeAll();
        this.toastr.success(resp);
        this.getRFIDs(this.pageList, '');
      }
      else {
        this.toastr.error(this.translate.instant('rfid.updateFail'))
      }
    },
      error => {
        this.toastr.error(error);
      }))
  }

  deleteRfid(item) {
    this.deleteId = item.id_tag;
    this.deleteFeature();
  }

  deleteRfidById() {
    this.rfidSubscription.add(this.rfidService.deleteRfidCard(this.authenticationService.convertToBase64(this.deleteId)).subscribe((resp: any) => {
      if (!!resp) {
        this.toastr.success(resp.status_message);
        this.getRFIDs(this.pageList, '');
      }
      else {
        this.toastr.error(this.translate.instant('rfid.deleteFail'))
      }
    },
      error => {
        this.toastr.error(error);
      }
    ))
  }

  editAssignedRfid(item) {
    this.router.navigate(["/dashboard/rfid/edit-assign", { routeID: this.route.snapshot.paramMap.get('routeID') }], { queryParams: { "rfidId": this.authenticationService.convertToBase64(item.id_tag) } });
    this.breadcrumbService.emitBreadCrumbs(RouteConstants.RFID_EDIT);
  }

  assignRfid() {
    this.router.navigate(["/dashboard/rfid/assign", { routeID: this.route.snapshot.paramMap.get('routeID') }]);
    this.breadcrumbService.emitBreadCrumbs(RouteConstants.RFID_ASSIGN);
  }

  rfidDetails(item) {
    this.rfidTag = item.id_tag;
      this.rfidService.getRfidDetailsById(this.authenticationService.convertToBase64(this.rfidTag)).subscribe(resp => {
      Object.keys(resp).map(x => {
        if (resp[x]) {
          (!resp[x] || resp[x] == '') ? resp[x] = 'NA' : null;
        }
      })
      this.desplayRfid = resp;
      let dialogRef = this.dialog.open(this.viewRfidDetails, {
        height: '500px',
        width: '800px'
      }).afterClosed().subscribe((res: any) => {
      })
    })
  }

  userDetail(item) {
    this.userService.getUserDetails(item.user_id).subscribe((resp: any) => {
      if (!!resp) {
        this.userDetails = resp.data;
        let empty = 'NA';
        let event = this.userDetails
        event.username = !event.username ? empty : event.username;
        event.email = !event.email ? empty : event.email;
        event.emailValidated = event.email_validated;
        event.mobile = !event.mobile ? empty : event.mobile;
        event.mobileValidated = event.mobile_validated;
        event.countryCode = !event.country_code ? '' : event.country_code;
        event.roles = (!event.roles && event.roles.length > 0) ? empty : event.roles[0].name;
        event.status = !event.status ? empty : event.status.toUpperCase();
        event.tenantId = !event.tenant_id ? empty : event.tenant_id;
        event.signupType = !event.signup_type ? empty : event.signup_type;
        event.prefLanguage = !event.pref_language ? empty : event.pref_language.toUpperCase();
        event.pancard = !event.pancard ? empty : event.pancard;
        event.gstNumber = !event.gst_number ? empty : event.gst_number;
        event.state = !event.state ? empty : event.state;
        event.vehicleRegNo = !event.vehicle_reg_no ? empty : event.vehicle_reg_no;

        let dialogRef = this.dialog.open(this.viewUserDetails, {
          height: '500px',
          width: '800px'
        }).afterClosed().subscribe((res: any) => {
        })
      } else {
        this.toastr.error(this.translate.instant('generalTable.noRecord'));
      }
    }, error => {
      this.toastr.error(this.translate.instant('generalTable.noRecord'));
    })
  }

  ngOnDestroy() {
    this.rfidSubscription && this.rfidSubscription.unsubscribe();
  }

  linkClick(event) {
    if (event.column.columnDef == "userDetails") {
      this.userDetail(event.row);
    }
    else if (event.column.columnDef == "idTag") {
      this.rfidDetails(event.row);
    }
  }

  buttonClick(result: string[]) {
    if (result[0] == 'delete') {
      let item = this.rfidAssignedList.filter(res => res.rfidTag == result[1])
      this.deleteRfid(item[0])
    } else if ((result[0] == 'edit')) {
      let item = this.rfidAssignedList.filter(res => res.rfidTag == result[1])
      this.editAssignedRfid(item[0]);
    } else if ((result[0] == 'block' || result[0] == 'unblock')) {
      let item = this.rfidAssignedList.filter(res => res.rfidTag == result[1])
      this.blockCard(item[0]);
    }
  }

  loadData(value: any) {
    let val = {
      currentPage: value.currentPage,
      pageSize: value.pageSize
    }
    this.pageList.pageSize = value.pageSize;
    this.getRFIDs(val, '')
  }

  sortClick(event: any) {
    this.sortColumn = event.active;
    this.sortDirection = event.direction;
    this.getRFIDs(this.pageList, '');
  }

  applyFilter(filteredData: string) {
    this.getRFIDs(this.pageList, filteredData);
  }

  actionFeature(event) {
    this.router.navigate(['/dashboard/rfid/create', { routeID: this.route.snapshot.paramMap.get('routeID') }]);
    this.breadcrumbService.emitBreadCrumbs(RouteConstants.RFID_CREATE);
  }

  actionClick(event) {
    this.getRFIDs(this.pageList, '');
  }

  deleteFeature(): void {
    let dialogRef = this.dialog.open(GeneralDialogComponent, {
      width: '50vw',
      height: '200px',
      data: { component: ConfirmDialogComponent, button: this.translate.instant('faq.confirmButton'), title: this.translate.instant('createStation.confiration'), otherbtn: this.translate.instant('faq.confirmNo'), message: this.translate.instant('rfid.deleteTitle') }
    }).afterClosed().subscribe(res => {
      if (res && res == 'Yes') {
        this.deleteRfidById();
      }
    });
  }

  unblockFeature(): void {
    let dialogRef = this.dialog.open(GeneralDialogComponent, {
      width: '50vw',
      height: '200px',
      data: { component: ConfirmDialogComponent, button: this.translate.instant('faq.confirmButton'), title: this.translate.instant('createStation.confiration'), otherbtn: this.translate.instant('faq.confirmNo'), message: this.translate.instant('rfid.unBlockTitle') }
    }).afterClosed().subscribe(res => {
      if (res && res == 'Yes') {
        this.unblockById();
      }
    });
  }
  checkPermission(id: number, permission: string): boolean {
    return this.userInfoService.filterPermission(id, permission)
  }
}

export interface RFIDAssignedList {
  rfidTag: string;
  userDetails: string;
  userMobile: string;
  createdByName : string;
  status: string;
  masterRfidCard: string;
  blockStatus: boolean;
  unblockStatus: boolean;
  disableDelete: boolean;
}
